import axios from '../../utils/axios';

export default function addLGCollectionTarget(adminId, data) {
    return (
        axios.post(`/admin/${adminId}/lGCollectionTarget`,  data )
    )
}
